<template>
	<el-drawer
		title="报名详情"
		:visible.sync="drawer"
		class="surveyWatchInfoDrawer"
		:class="{
			surveyWatchInfoDrawerWithBottom: 1,
		}"
		:append-to-body="true"
		:size="480"
		@closed="onDrawerClosed"
	>
		<div class="surveyWatchUserInfo">
			<div class="surveyWatchUserInfoBox">
				<img class="surveyWatchUserInfoAvatar" :src="info.avatarUrl" alt="" />
				<div class="surveyWatchUserInfoNickname">{{ info.nickname }}</div>
			</div>
		</div>
		<div class="surveyWatchSignInfo">
			<div class="surveyWatchSignInfoTitle">报名信息</div>
			<div class="surveyWatchSignInfoBox">
				<template v-if="oldMark">
					<div v-for="(value, key) in surveyFields" :key="key" class="surveyWatchSignInfoItem">
						<div class="surveyWatchSignInfoItemLabel">{{ value.title }}</div>
						<div class="surveyWatchSignInfoItemValue">
							<template v-if="value.type == 2">
								<img :src="info.answerDetail[value.id]" alt="" />
							</template>
							<template>
								{{ info.answerDetail[value.id] }}
							</template>
						</div>
					</div>
				</template>
				<template v-else>
					<div v-for="(value, key) in info.answerUnitList" :key="key" class="surveyWatchSignInfoItem">
						<div class="surveyWatchSignInfoItemLabel">{{ value.surveyQuestionName }}</div>
						<div class="surveyWatchSignInfoItemValue">
							<template v-if="value.surveyQuestionType == 4">
								<img :src="value.answerList[0].answerUrl" alt="" />
							</template>
							<template v-else>
								<span v-for="(item, index) in value.answerList" :key="index"
									>{{ item.answer }}{{ index == value.answerList.length - 1 ? '' : '、' }}</span
								>
							</template>
						</div>
					</div>
				</template>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { surveyAnswer, errors } from '@/services/indexnew';
export default {
	components: {},
	props: {
		oldMark: {
			type: Boolean,
			required: true,
		},
		surveyId: {
			type: [String, Number],
			required: true,
		},
	},
	data() {
		return {
			drawer: false,
			refuseLoading: false,
			passLoading: false,
			info: {},
			surveyFields: [],
		};
	},
	methods: {
		show(info) {
			console.log(info);
			if (this.oldMark) {
				this.getOldListTh();
			}
			this.info = info;
			this.drawer = true;
		},
		async getOldListTh() {
			try {
				const { ok, data } = await surveyAnswer.getDataStatistics(this.surveyId);
				if (!ok) {
					return;
				}
				this.surveyFields = data.data;
				console.log(data.data);
			} catch (err) {
				errors(err);
			}
		},
		onRefuseClick() {
			this.refuseLoading = true;
			this.$emit('refuse', this.info);
		},
		onPassClick() {
			this.passLoading = true;
			this.$emit('pass', this.info);
		},
		clearLoading() {
			this.passLoading = false;
			this.refuseLoading = false;
		},
		onDrawerClosed() {
			this.surveyFields = [];
			this.info = {};
		},
	},
};
</script>
<style lang="less">
.surveyWatchInfoDrawer {
	.el-drawer__header {
		margin: 0;
		padding: 0 16px;
		height: 52px;
		border-bottom: 1px solid #dcdee0;
		font-size: 14px;
		font-weight: 500;
		color: #323233;
		line-height: 20px;
	}
	.el-drawer__body {
		padding: 24px;
		position: relative;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	.bottomBar {
		height: 64px;
		border-top: 1px solid #dcdee0;
		padding: 0 16px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		.el-button {
			height: 32px;
			border-radius: 2px;
			padding: 0 16px;
		}
		.el-button--default {
			border: 1px solid rgba(245, 63, 63, 1);
			color: rgba(245, 63, 63, 1);
			&:hover {
				border: 1px solid rgba(245, 63, 63, 1);
				color: #fff;
				background-color: rgba(245, 63, 63, 1);
			}
		}

		.el-button--primary {
			border-color: #2c7dfa;
			background-color: #2c7dfa;
			&:hover {
				border-color: #66b1ff;
				background-color: #66b1ff;
			}
		}
	}
	&.surveyWatchInfoDrawerWithBottom {
		.el-drawer__body {
			padding-bottom: 82px;
		}
	}

	.surveyWatchUserInfo {
		display: flex;
		align-items: center;
		justify-content: space-between;
		.surveyWatchUserInfoBox {
			display: flex;
			align-items: center;
		}
		.surveyWatchUserInfoAvatar {
			width: 60px;
			height: 60px;
			margin-right: 12px;
			border-radius: 50%;
		}
		.surveyWatchUserInfoNickname {
			font-size: 16px;
			font-weight: 500;
			color: rgba(50, 50, 51, 1);
		}
	}
	.surveyWatchSignInfo {
		margin-top: 24px;
		flex: 1;
		overflow: hidden;
		.surveyWatchSignInfoTitle {
			font-size: 14px;
			line-height: 20px;
			font-weight: 500;
			color: rgba(39, 41, 36, 1);
		}
		.surveyWatchSignInfoBox {
			margin-top: 16px;
			background: rgba(220, 222, 224, 0.1);
			padding: 24px;
			box-sizing: border-box;
			max-height: calc(100% - 20px - 24px);
			overflow: auto;
			.surveyWatchSignInfoItem {
				display: flex;
				& + .surveyWatchSignInfoItem {
					margin-top: 16px;
				}
				.surveyWatchSignInfoItemLabel {
					flex-shrink: 0;
					width: 84px;
					font-size: 14px;
					line-height: 20px;
					color: rgba(134, 144, 156, 1);
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.surveyWatchSignInfoItemValue {
					font-size: 14px;
					line-height: 20px;
					color: rgba(29, 33, 41, 1);
					margin-left: 24px;
					word-break: break-all;
					img {
						width: 100%;
					}
				}
			}
		}
	}
}
</style>
